// Split out of ChatSession.js: ChatSettings.js needs extractVersion, and
// ChatSession.js imports ChatSettings, which made them a circular import.
export const extractVersion = (model) => {
  if (/-v\d+/.test(model)) {
    return ` (${model.replace(/^.*?-(v.*)$/, "$1")})`;
  }
  return "";
};
